export default {
  en: {
    start: 'Start',
    end: 'End',
  },
};
